import { render, staticRenderFns } from "./dispatchCarDetails.vue?vue&type=template&id=f33546ae&scoped=true&"
import script from "./dispatchCarDetails.vue?vue&type=script&lang=js&"
export * from "./dispatchCarDetails.vue?vue&type=script&lang=js&"
import style0 from "./dispatchCarDetails.vue?vue&type=style&index=0&id=f33546ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33546ae",
  null
  
)

export default component.exports